import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Instagram } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-white border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-8 h-8 bg-[#6B9CAD] rounded flex items-center justify-center">
                <svg viewBox="0 0 24 24" className="w-6 h-6 text-white" fill="currentColor">
                  <path d="M4 4h6l2 4-2 4H4V4zm10 0h6l2 4-2 4h-6l-2-4 2-4z" opacity="0.6"/>
                  <path d="M4 12h6l2 4-2 4H4v-8z" opacity="0.8"/>
                  <path d="M14 12h6l2 4-2 4h-6l-2-4 2-4z"/>
                </svg>
              </div>
            </div>
            <p className="text-sm text-gray-600 mb-2">Address: 3600 Inwood St.</p>
            <p className="text-sm text-gray-600 mb-2">California, CA. 90045</p>
            <p className="text-sm text-gray-600 mb-2">+1 (123) 456-7890</p>
            <p className="text-sm text-gray-600 mb-2">contact@casualcountry.com</p>
            <p className="text-sm text-gray-600">info@casualcountry.com</p>

            <div className="mt-6">
              <a 
                href="https://maps.google.com/?q=3600+Inwood+St+California+CA+90045" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-sm text-gray-600 hover:text-[#6B9CAD] flex items-center"
              >
                Get directions →
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-bold mb-4 text-sm">SHOP</h3>
            <ul className="space-y-2 text-sm text-gray-600">
              <li><Link to="/collections?category=Hoodies" className="hover:text-[#6B9CAD]">Hoodies</Link></li>
              <li><Link to="/collections?category=Sweatshirt" className="hover:text-[#6B9CAD]">Sweatshirt</Link></li>
              <li><Link to="/collections?category=Tees" className="hover:text-[#6B9CAD]">Tees</Link></li>
              <li><Link to="/collections?category=Tights" className="hover:text-[#6B9CAD]">Tights</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-bold mb-4 text-sm">INFORMATION</h3>
            <ul className="space-y-2 text-sm text-gray-600">
              <li><button type="button" className="hover:text-[#6B9CAD] text-left">Terms & Conditions</button></li>
              <li><button type="button" className="hover:text-[#6B9CAD] text-left">Privacy Policy</button></li>
              <li><button type="button" className="hover:text-[#6B9CAD] text-left">Return Policy</button></li>
            </ul>
          </div>

          <div>
            <h3 className="font-bold mb-4 text-sm">Sign Up for Email</h3>
            <p className="text-sm text-gray-600 mb-4">
              Sign up to get first dibs on new arrivals, sales, exclusive content, events, and more!
            </p>
            <div className="flex">
              <input
                type="email"
                placeholder="Enter email address"
                className="flex-1 px-4 py-2 border border-gray-300 rounded-l text-sm focus:outline-none focus:border-[#6B9CAD]"
              />
              <button className="bg-black text-white px-6 py-2 rounded-r text-sm hover:bg-gray-800 transition">
                Subscribe
              </button>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-200 pt-8 flex flex-col md:flex-row justify-between items-center">
          <div className="flex space-x-6 mb-4 md:mb-0">
            <a 
              href="https://www.facebook.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-600 hover:text-[#6B9CAD]"
              aria-label="Facebook"
            >
              <Facebook size={20} />
            </a>
            <a 
              href="https://www.twitter.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-600 hover:text-[#6B9CAD]"
              aria-label="Twitter"
            >
              <Twitter size={20} />
            </a>
            <a 
              href="https://www.instagram.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-600 hover:text-[#6B9CAD]"
              aria-label="Instagram"
            >
              <Instagram size={20} />
            </a>
          </div>

          <div className="flex space-x-3">
            <div className="w-12 h-8 bg-gray-200 rounded flex items-center justify-center text-xs font-bold">
              VISA
            </div>
            <div className="w-12 h-8 bg-gray-200 rounded flex items-center justify-center text-xs font-bold">
              MC
            </div>
            <div className="w-12 h-8 bg-gray-200 rounded flex items-center justify-center text-xs font-bold">
              AMEX
            </div>
            <div className="w-12 h-8 bg-gray-200 rounded flex items-center justify-center text-xs font-bold">
              PP
            </div>
          </div>
        </div>

        <div className="text-center mt-8 text-sm text-gray-500">
          © 2025 Casual Country. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
